import React from "react";

interface IconProps {
  style?: React.CSSProperties;
}

const RightArrowIcon: React.FC<IconProps> = ({ style }) => (
  <svg
    width='25'
    height='44'
    viewBox='0 0 25 44'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={style}
  >
    <path
      d='M3.22201 40.6667L21.8887 22.0001L3.22201 3.33342'
      stroke='#003C73'
      strokeWidth='7'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default RightArrowIcon;
